(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  const initFooterLogoScroll = () => {
    document.querySelectorAll('[data-scroll-top]').forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterLogoScroll);
  } else {
    initFooterLogoScroll();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();
        // Simplified dropdown behavior - no mega menu functionality
        this.setupHoverEvents();
      }

      setupHoverEvents() {
        // Add specific click handlers for main-nav__item-content links first
        const contentLinks = this.querySelectorAll('a.main-nav__item-content');
        contentLinks.forEach(link => {
          link.addEventListener('click', (e) => {
            // Allow the link to work normally - stop all interference
            e.stopPropagation();
            e.stopImmediatePropagation();
            // Don't prevent default - let the link navigate
          });
        });

        // Add hover event listeners for child-nav__item--toggle elements
        const toggleElements = this.querySelectorAll('.child-nav__item--toggle');
        
        toggleElements.forEach(toggle => {
          // Get the disclosure panel - it's a sibling of the summary element
          const disclosure = toggle.closest('details');
          const grandchildPanel = disclosure ? disclosure.querySelector('.disclosure__panel') : null;
          
          // Handle click events for mobile devices
          toggle.addEventListener('click', (e) => {
            // Check if the click is on a link element with main-nav__item-content class
            const linkElement = e.target.closest('a.main-nav__item-content');
            if (linkElement) {
              // Allow link clicks to proceed normally - don't interfere at all
              e.stopPropagation();
              return;
            }
            
            // Only prevent default on desktop (hover behavior) for non-link clicks
            // Allow normal click behavior on mobile
            if (window.matchMedia(theme.mediaQueries.md).matches) {
              e.preventDefault();
            }
          });
          
          // Add hover events to the toggle (desktop only)
          toggle.addEventListener('mouseenter', () => {
            // Only use hover behavior on desktop
            if (window.matchMedia(theme.mediaQueries.md).matches) {
              this.openOnHover(toggle);
            }
          });
          
          toggle.addEventListener('mouseleave', (e) => {
            // Only use hover behavior on desktop
            if (window.matchMedia(theme.mediaQueries.md).matches) {
              // Check if mouse is moving to the grandchild panel
              const relatedTarget = e.relatedTarget;
              
              if (!grandchildPanel || !grandchildPanel.contains(relatedTarget)) {
                // Add a small delay to prevent flickering
                setTimeout(() => {
                  // Check again if mouse is still outside
                  if (!toggle.matches(':hover') && (!grandchildPanel || !grandchildPanel.matches(':hover'))) {
                    this.closeOnHoverLeave(toggle);
                  }
                }, 100);
              }
            }
          });
          
          // Add hover events to the grandchild panel to keep it open (desktop only)
          if (grandchildPanel) {
            // Handle hover on the panel itself
            grandchildPanel.addEventListener('mouseenter', () => {
              // Only use hover behavior on desktop
              if (window.matchMedia(theme.mediaQueries.md).matches) {
                // Ensure the panel stays open when hovering over it
                this.openOnHover(toggle);
              }
            });
            
            grandchildPanel.addEventListener('mouseleave', (e) => {
              // Only use hover behavior on desktop
              if (window.matchMedia(theme.mediaQueries.md).matches) {
                // Check if mouse is moving back to toggle or bridge
                const relatedTarget = e.relatedTarget;
                if (!toggle.contains(relatedTarget) && !grandchildPanel.contains(relatedTarget)) {
                  this.closeOnHoverLeave(toggle);
                }
              }
            });

            // Bridge tracking removed - no longer detecting mouse movement in bridge area
          }
        });
      }

      openOnHover(toggleElement) {
        const disclosure = toggleElement.closest('details');
        if (disclosure && !disclosure.classList.contains('is-open')) {
          disclosure.classList.add('is-open');
          disclosure.open = true;
        }
      }

      closeOnHoverLeave(toggleElement) {
        const disclosure = toggleElement.closest('details');
        if (disclosure && disclosure.classList.contains('is-open')) {
          disclosure.classList.remove('is-open');
          disclosure.open = false;
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        // Simplified dropdown behavior
        super.handleToggle(e);
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
